var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "brush",
    clipPath: "url(#clip0_894_1628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.2852 3.56934H14.9518C6.61849 3.56934 3.28516 6.90267 3.28516 15.236V25.236C3.28516 33.5693 6.61849 36.9027 14.9518 36.9027H24.9518C33.2852 36.9027 36.6185 33.5693 36.6185 25.236V21.9027",
    stroke: "#0D0D0D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.4658 6.1697C34.4158 11.2864 29.2658 18.253 24.9658 21.703L22.3324 23.803C21.9991 24.053 21.6658 24.253 21.2824 24.403C21.2824 24.153 21.2658 23.903 21.2324 23.6364C21.0824 22.5197 20.5824 21.4697 19.6824 20.5864C18.7658 19.6697 17.6658 19.153 16.5324 19.003C16.2658 18.9864 15.9991 18.9697 15.7324 18.9864C15.8824 18.5697 16.0991 18.1864 16.3824 17.8697L18.4824 15.2364C21.9324 10.9364 28.9158 5.75304 34.0158 3.70304C34.7991 3.40304 35.5658 3.63637 36.0491 4.1197C36.5491 4.6197 36.7824 5.38637 36.4658 6.1697Z",
    stroke: "#0D0D0D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.3008 24.386C21.3008 25.8526 20.7341 27.2526 19.6841 28.3193C18.8675 29.136 17.7675 29.7026 16.4508 29.8693L13.1675 30.2193C11.3841 30.4193 9.85081 28.9026 10.0508 27.086L10.4008 23.8026C10.7175 20.886 13.1508 19.0193 15.7508 18.9693C16.0175 18.9526 16.2841 18.9693 16.5508 18.986C17.6841 19.136 18.7841 19.6526 19.7008 20.5693C20.6008 21.4693 21.1008 22.5026 21.2508 23.6193C21.2841 23.886 21.3008 24.1526 21.3008 24.386Z",
    stroke: "#0D0D0D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M26.3655 20.2024C26.3655 16.7191 23.5488 13.8857 20.0488 13.8857",
    stroke: "#0D0D0D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_894_1628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.23584)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush);
export default __webpack_public_path__ + "static/media/brush.5062e6636680305ca9442e30c940e4b3.svg";
export { ForwardRef as ReactComponent };